import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import type { components } from '@/api/types.gen'

export type Settings = components['schemas']['Settings']

export const settingsKey = ['settings'] as const

export async function fetchSettings(): Promise<Settings> {
  const { data } = await api.GET('/api/settings')
  return data as Settings
}

/**
 * Instance configuration: the base currency prices are converted through and the
 * upload limit. It changes only when the server is reconfigured, so it is
 * fetched once and kept.
 */
export function useSettings() {
  return useQuery({ queryKey: settingsKey, queryFn: fetchSettings, staleTime: Infinity })
}
